var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"company-selector__list",class:{
    'company-selector__list--loading': _vm.isLoading
  }},[(_vm.items.length <= 0)?_c('p',{staticClass:"company-selector__empty",domProps:{"textContent":_vm._s(_vm.$t('NO_RESULT'))}}):_vm._e(),_vm._l((_vm.items),function(item){return _c('company-list-item',{key:item.objectID,class:{
      'company-selector__item--selected': (item.user_uid === _vm.selectedCompanyId),
    },attrs:{"item":item},nativeOn:{"click":function($event){return _vm.setSelectedCompany(item)}}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }